import { useEffect, useMemo } from 'react';
import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { buildUrl, parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { isRpcError } from '../../../utils/error';
import { trackPotentialBannerInteraction } from '../../../utils/ums';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const url = path => {
  const isQAProxy = window.location.hostname.indexOf('wthubspot') >= 0;
  const isQA = enviro.isQa() || isQAProxy;
  const baseUrl = getFullUrl('app', {
    envOverride: isQA ? 'qa' : 'prod'
  });
  const {
    protocol,
    hostname
  } = parseUrl(baseUrl);
  return buildUrl({
    protocol,
    hostname,
    path
  });
};
const AssignSeatButtonBase = ({
  apiName,
  children,
  uiButtonProps,
  trackingData,
  upgradeConfig,
  level,
  'data-test-id': dataTestId,
  'data-selenium-id': dataSeleniumId
}) => {
  const trackingProperties = useMemo(() => getTrackingProperties({
    apiName,
    trackingData,
    upgradeConfig,
    sourceKey: 'ASSIGN_SEAT'
  }), [apiName, trackingData, upgradeConfig]);
  useEffect(() => {
    track('interaction', Object.assign({
      action: 'viewed assign seat'
    }, trackingProperties, {
      isPrimaryCta: level === 0,
      isSecondaryCta: level === 1
    }));
  }, [trackingProperties, level]);
  const trackClick = () => {
    track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, trackingProperties));
    track('interaction', Object.assign({
      action: 'clicked assign seat'
    }, trackingProperties, {
      isPrimaryCta: level === 0,
      isSecondaryCta: level === 1
    }));
    if (upgradeConfig) {
      trackPotentialBannerInteraction(upgradeConfig).catch(error => {
        if (!isRpcError(error) || error.cause.status !== 0) {
          Raven.captureException(error, {
            fingerprint: ['Failed to submit interaction from AssignSeatButton'],
            extra: {
              upgradeConfig
            }
          });
        }
      });
    }
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    href: url(`/settings/${PortalIdParser.get()}/users/seats`),
    external: true,
    onClick: trackClick,
    truncate: true,
    truncateStringProps: {
      justifyContent: 'center'
    }
  }, uiButtonProps, {
    "data-test-id": dataTestId,
    "data-selenium-id": dataSeleniumId,
    children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.buttons.assignSeat"
    })
  }));
};
export const AssignSeatButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.ASSIGN_SEAT_BUTTON,
  children: /*#__PURE__*/_jsx(AssignSeatButtonBase, Object.assign({}, props))
});